/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueDropdownServiceTypeComponent } from './sysque-dropdown-service-type.component';
import { SysqueSelectBoxModule } from '../sysque-select-box';

@NgModule({
  declarations: [SysqueDropdownServiceTypeComponent],
  imports: [CommonModule, SysqueSelectBoxModule],
  exports: [SysqueDropdownServiceTypeComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueDropdownServiceTypeModule {}
